// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { Ellipsified } from "metabase/common/components/Ellipsified";
import { Icon } from "metabase/ui";

export const CardIcon = styled(Icon)`
  display: block;
  flex: 0 0 auto;
  color: var(--mb-color-brand);
  width: 2rem;
  height: 2rem;
`;

export const CardTitle = styled(Ellipsified)`
  color: var(--mb-color-text-dark);
  font-size: 1rem;
  font-weight: bold;
  margin: 0rem 1rem;
  width: 10em;
  text-align: center;
`;
